<template>
  <div>
    <template v-if="$route.name === 'ClientTypeCreate'">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'ClientTypeList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <Form
                    :handle-submit="onSendForm"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations"/>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  components: {
    Form
  },

  data () {
    return {
      item: {
        title: '',
        description: '',
        roles: [''],
        defaultRoute: '/admin/timetable/dashboard'
      }
    }
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.$router.push({ name: 'ClientTypeList', params: { id: created['@id'] } })
    }
  },

  beforeCreate () {
    checkPagePermission('appConfiguration', 'AppConfiguration')
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapGetters({
      created: 'clienttype/create/created',
      violations: 'clienttype/create/violations',
      isLoading: 'clienttype/create/isLoading'
    })
  },
  methods: {
    onSendForm () {
      this.create(this.item)
    },
    ...mapActions({
      create: 'clienttype/create/create',
      reset: 'clienttype/create/reset'
    }),
    updateField (field, value) {
      if (field === 'roles') {
        this.item.roles[0] = value
      } else {
        Object.assign(this.item, { [field]: value })
      }
    }
  }
}
</script>

<style scoped>

</style>
